import React from 'react'
import PropTypes from 'prop-types'

class FlowStep extends React.PureComponent {

  static propTypes = {
    stepKey: PropTypes.string.isRequired,
    component: PropTypes.func.isRequired,
    componentProps: PropTypes.object,
    default: PropTypes.bool,
    condition: PropTypes.func,
    alwaysCheck: PropTypes.bool,
    ignoreWhenBacking: PropTypes.bool,
    requestNextStep: PropTypes.func,
    requestPreviousStep: PropTypes.func,
    requestExit: PropTypes.func,
    requestSpecificStep: PropTypes.func,
    loading: PropTypes.bool,
  }

  static defaultProps = {
    componentProps: {},
    default: false,
    condition: undefined,
    alwaysCheck: false,
    ignoreWhenBacking: false,
  }

  render() {
    const componentProps = {
      ...this.props.componentProps,
      requestNextStep: this.props.requestNextStep,
      requestPreviousStep: this.props.requestPreviousStep,
      requestExit: this.props.requestExit,
      requestSpecificStep: this.props.requestSpecificStep,
      stepKey: this.props.stepKey,
      loading: this.props.loading,
    }
    return React.createElement(this.props.component, componentProps)
  }
}

export default FlowStep



// WEBPACK FOOTER //
// ./src/sections/flow/components/flowStep.jsx